import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { fetchIds } from "../Pages/Video/VideoActions";

const PreviousNextButtons = ({ type }) => {
  const [ids, setIds] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const videoParams = useSelector((state) => state.videoParams);
  const influencerParams = useSelector((state) => state.influencerParams);
  const productParams = useSelector((state) => state.productParams);

  useEffect(() => {
    const filters = {
      video: videoParams,
      product: productParams,
      influencer: influencerParams,
    };
    fetchIds(filters[type], type)
      .then((response) => {
        if (response) {
          setIds([...response]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const prevHandler = () => {
    const index = ids.findIndex((i) => i === params.id);
    if (index >= 0) {
      navigate(`/${type}s/${ids[index - 1]}`);
    }
  };

  const nextHandler = () => {
    const index = ids.findIndex((i) => i === params.id);
    if (index >= 0) {
      navigate(`/${type}s/${ids[index + 1]}`);
    }
  };

  const style = { color: "#6E6B7A", fontSize: "18px" };
  const idNotFound = !ids.includes(params.id);
  
  return (
    <div className="header-pagination">
      <div
        role="button"
        hidden={ids[0] === params.id || idNotFound}
        onClick={prevHandler}
        style={style}
      >
        <img
          width={10}
          style={{ marginRight: "10px" }}
          src={require("@images/videos/left-arrow.png").default}
        />
        Previous {type}
      </div>
      <div
        role="button"
        hidden={ids[ids.length - 1] === params.id || idNotFound}
        onClick={nextHandler}
        style={style}
        className="ms-auto"
      >
        Next {type}
        <img
          width={10}
          style={{ marginLeft: "10px" }}
          src={require("@images/videos/right-arrow.png").default}
        />
      </div>
    </div>
  );
};

PreviousNextButtons.propTypes = {
  type: PropTypes.string,
  isVideoDetailPage: PropTypes.bool,
};

export default PreviousNextButtons;
